var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 22,
    viewBox: "0 0 26 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_241_2219)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.75 0.63501H4.25C1.98 0.63501 0.130005 2.48501 0.130005 4.75501V14.975C0.130005 18.335 2.86 21.065 6.22 21.065H19.77C23.13 21.065 25.86 18.335 25.86 14.975V4.75501C25.87 2.48501 24.02 0.63501 21.75 0.63501ZM21.06 3.36501L14.34 11.065C14 11.455 13.52 11.675 13 11.675C12.48 11.675 12 11.455 11.66 11.065L4.94 3.36501H21.06ZM19.78 18.345H6.22C4.36 18.345 2.85 16.835 2.85 14.975V5.13501L9.60001 12.855C10.46 13.835 11.7 14.395 13 14.395C14.3 14.395 15.54 13.835 16.4 12.855L23.14 5.12501V14.975C23.14 16.835 21.63 18.345 19.78 18.345Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_241_2219"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 21,
    fill: "white",
    transform: "translate(0 0.35498)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.b1b09aadd552749c6e251261b21ee536.svg";
export { ForwardRef as ReactComponent };